<app-periodo-dashboard
  [periodos]="periodosAsistencia"
  [periodoInicial]="periodoInicial"
  prefijo="asistencia"
  (cambio)="onPeriodo($event)">
  <div meta class="tickets-toolbar__meta">
    <span>{{ totalDias }} dias con veredicto</span>
    <strong>{{ rango.inicio | date:'dd/MM/yyyy' }} - {{ rango.fin | date:'dd/MM/yyyy' }}</strong>
  </div>
</app-periodo-dashboard>

<div class="tickets-alert" *ngIf="errorCarga">
  {{ errorCarga }}
</div>

<section class="tickets-kpis tickets-kpis--incidents" aria-label="Indicadores principales de asistencia">
  <article class="ticket-kpi" *ngFor="let kpi of kpis" [ngClass]="kpi.className">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && kpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Veredictos del periodo</span>
        <h2>Dias evaluados por estatus</h2>
      </div>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalDias }}</strong>
          <span>Dias</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of estatusItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && estatusItems.length === 0">
      Todavia no hay dias evaluados en el periodo. Los veredictos aparecen cuando la app registra o el cierre diario corre.
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Canal de registro</span>
        <h2>Como se registro la entrada</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="origenItems.length > 0; else emptyOrigenTpl">
      <div class="tickets-bar" *ngFor="let item of origenItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre }}</span>
          <strong>{{ getBarPercent(item, totalOrigen) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i, totalOrigen)"></span>
        </div>
        <small>{{ item.valor }} dias</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tendencia</span>
        <h2>Faltas y retardos por mes (ultimos 12 meses)</h2>
      </div>
    </div>

    <div class="incident-months" *ngIf="mesItems.length > 0; else emptyMesesTpl">
      <div class="incident-month" *ngFor="let item of mesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getBarStyle(item, i, mesMax)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>

  <div class="asistencia-columna">
    <article class="tickets-card">
      <div class="tickets-card__header">
        <div>
          <span>Lectura rapida</span>
          <h2>Que atender</h2>
        </div>
      </div>

      <div class="asistencia-atender">
        <div class="asistencia-atender__item" *ngFor="let pendiente of pendientes">
          <strong class="asistencia-atender__valor">{{ pendiente.valor }}</strong>
          <span class="asistencia-atender__texto">{{ pendiente.texto }}</span>
          <button
            *ngIf="pendiente.ruta"
            type="button"
            class="tickets-link-button"
            (click)="abrirPendiente(pendiente)">Abrir</button>
        </div>
      </div>
    </article>

    <article class="tickets-card">
      <div class="tickets-card__header">
        <div>
          <span>Sitios</span>
          <h2>Sitios con mas faltas y retardos</h2>
        </div>
      </div>

      <div class="tickets-area-list" *ngIf="sitioItems.length > 0; else emptySitiosTpl">
        <div class="tickets-area" *ngFor="let item of sitioItems; let i = index">
          <span class="tickets-area__rank">{{ i + 1 }}</span>
          <div>
            <strong>{{ item.nombre }}</strong>
            <small>{{ item.valor }} dias</small>
          </div>
          <span class="tickets-area__percent">{{ getBarPercent(item, totalSitios) }}%</span>
        </div>
      </div>
    </article>
  </div>
</section>

<section class="tickets-card tickets-card--table">
  <div class="tickets-card__header">
    <div>
      <span>Actividad reciente</span>
      <h2>Ultimas faltas y retardos</h2>
    </div>
    <button type="button" class="tickets-link-button" (click)="abrirMonitoreo()">Ver todos</button>
  </div>

  <div class="tickets-table-wrap" *ngIf="recientes.length > 0; else emptyRecientesTpl">
    <table class="tickets-table">
      <thead>
        <tr>
          <th>Empleado</th>
          <th>Fecha</th>
          <th>Estatus</th>
          <th>Retardo</th>
          <th>Entrada</th>
          <th>Sitio</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let renglon of recientes">
          <td>{{ renglon.nombreEmpleado || renglon.usuario }}</td>
          <td>{{ renglon.fecha | date:'dd/MM/yyyy' }}</td>
          <td>
            <span class="ticket-status" [ngClass]="getEstatusClass(renglon)">
              {{ renglon.estatus }}
            </span>
          </td>
          <td>{{ renglon.minutosRetardo ? renglon.minutosRetardo + ' min' : '--' }}</td>
          <td>{{ horaDe(renglon.horaEntradaReal) || 'Sin checada' }}</td>
          <td>{{ renglon.nombreUbicacion || 'Home office' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<ng-template #emptyOrigenTpl>
  <div class="tickets-empty">Sin entradas registradas en el periodo.</div>
</ng-template>

<ng-template #emptyMesesTpl>
  <div class="tickets-empty">Sin faltas ni retardos en los ultimos doce meses.</div>
</ng-template>

<ng-template #emptySitiosTpl>
  <div class="tickets-empty">Ningun sitio con faltas o retardos en el periodo.</div>
</ng-template>

<ng-template #emptyRecientesTpl>
  <div class="tickets-empty">No hay faltas ni retardos recientes para mostrar.</div>
</ng-template>
